import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  notification,
  Card,
  Modal,
  Space,
  Popconfirm,
  Table,
  Alert,
} from 'antd';

import BreadcrumbContainer from '../../containers/Breadcrumb';
import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import MESSAGES from '../../enums/Messages';

import {
  post,
  put,
  remove,
  ajaxTable as filterAjaxTable,
  info as infoPayments,
  productsTable,
} from '../../api/module/term_payment';
import { catchException } from '../../utils/helpers/helpers';
import TermPaymentForm from './Form';
import AjaxTable from '../../components/AjaxTable';

const { Title, Paragraph } = Typography;

const productColumns = [
  {
    title: 'No.',
    dataIndex: 'codigo',
    width: '3rem',
    align: 'center',
  },
  {
    title: 'Productos y/o entregables',
    dataIndex: 'producto_nombre',
    width: '20rem',
  },
  {
    title: 'Tipo',
    dataIndex: 'tipo_nombre',
    align: 'center',
    width: '6rem',
  },
  {
    title: 'Estado Guardado',
    dataIndex: 'info_detallada',
    width: '6rem',
  },
  {
    title: 'Fijo o Variable',
    dataIndex: 'variable_nombre',
    align: 'center',
    width: '6rem',
  },
  {
    title: 'Unidades máximas',
    dataIndex: 'maximo_unitario',
    width: '8rem',
  },
  {
    title: 'Unidad',
    dataIndex: 'nombre_unitario',
    width: '8rem',
  },
  {
    title: 'Valor unidad',
    dataIndex: 'valor_unitario',
    width: '8rem',
    render: (t) =>
      t ? `$ ${t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : null,
  },
  {
    title: 'Valor máximo a pagar',
    dataIndex: 'valor_total',
    width: '8rem',
    render: (t) =>
      t ? `$ ${t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : null,
  },
  {
    title: 'Unidades por asignar',
    dataIndex: 'pago_up',
    width: '8rem',
    fixed: 'right',
    render: (t, record) => (record.variable ? t : null),
  },
  {
    title: 'Valor por asignar',
    key: 'valor_up',
    width: '8rem',
    fixed: 'right',
    render: (_, record) =>
      record.variable
        ? `$ ${(record.pago_up * record.valor_unitario)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
        : `$ ${(record.pago_up * record.valor_total)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
  },
];
export default function TermPayments({ match }) {
  const [term_id] = useState(parseInt(match.params.term_id));
  const [info, setInfo] = useState([]);

  const [initialValues, setInitialValues] = useState(null);
  const [reloadSource, setReloadSource] = useState();
  const [deleteID, setDeleteID] = useState(undefined);

  const [showProducts, setShowProducts] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Términos de referencia',
      to: `${INTERNAL_LINKS.TDR_HOME}`,
    },
    {
      text: 'Formulario de Términos de referencia',
      to: `${INTERNAL_LINKS.TERM}/${term_id}/${parseInt(
        match.params.project_id,
      )}/${parseInt(match.params.contract_id)}`,
    },
    {
      text: 'Pagos',
    },
  ];

  const getInfo = async () => {
    try {
      const response = await infoPayments(term_id);
      setInfo(response.data);
    } catch (error) {
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  function doReload() {
    setReloadSource({});
  }

  const columns = [
    {
      title: 'No. de Pago',
      dataIndex: 'numero',
    },
    {
      title: 'Valor del pago (incluyendo impuestos, tasas y contribuciones)',
      dataIndex: 'valor',
      render: (text) => {
        return `$ ${text
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
      },
    },
    {
      title: 'Acciones',
      key: 'acciones',
      fixed: 'right',
      // width: 125,
      render: (_, record) => {
        return (
          <Space direction={'vertical'} style={{ width: '100%' }}>
            <CustomButton
              block
              htmlType={'button'}
              text="Editar"
              onClick={() => setInitialValues(record)}
            />
            <CustomButton
              block
              type={'default'}
              htmlType={'button'}
              loading={deleteID}
              disabled={deleteID}
              danger
              text={
                <Popconfirm
                  title={MESSAGES.DELETE_CONFIRM_MSG}
                  onConfirm={() => deleteDataSource(record.id)}
                >
                  Eliminar
                </Popconfirm>
              }
            />
          </Space>
        );
      },
    },
  ];

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: 'Producto asociado',
        dataIndex: 'producto_nombre',
        render: (text, record) => `${record.codigo}. ${text}`,
      },
      {
        title: 'Fijo o Variable',
        dataIndex: 'variable',
        render: (t) => (t ? 'Variable' : t === false ? 'Fijo' : ''),
      },
      {
        title: 'Valor a pagar por producto',
        dataIndex: 'valor',
        render: (t) =>
          t ? `$ ${t.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : null,
      },
    ];
    return (
      <Table
        columns={columns}
        rowKey="id"
        dataSource={record.productos}
        pagination={false}
      />
    );
  };

  const save = async (data) => {
    try {
      let response;
      data['termino'] = term_id;
      if (!initialValues.id) {
        response = await post(data);
      } else {
        response = await put(initialValues.id, data);
      }
      setInfo((s) => ({
        ...s,
        valor_asignado: response.data.valor_asignado,
        max_num_pago: response.data.max_num_pago,
      }));
      setInitialValues();
      doReload();
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
    } catch (err) {
      catchException(err, MESSAGES.DESC_ERROR_POST_MSG);
      throw err;
    }
  };

  const deleteDataSource = async (id) => {
    try {
      setDeleteID(id);
      await remove(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
      setDeleteID();
      doReload();
    } catch (err) {
      setDeleteID();
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_DELETE_MSG,
        duration: 2,
      });
    }
  };

  return (
    <>
      <Modal
        destroyOnClose
        open={!!initialValues}
        footer={null}
        closable
        onCancel={() => setInitialValues()}
        title="Formulario de pago"
        width={'90%'}
      >
        <TermPaymentForm
          initialValues={initialValues}
          term_id={term_id}
          onSave={save}
          currencyText={info?.moneda_descripcion}
        />
      </Modal>

      <Modal
        destroyOnClose
        open={showProducts}
        footer={null}
        closable
        onCancel={() => setShowProducts(false)}
        title="Productos"
        width={'90%'}
      >
        <AjaxTable
          columns={productColumns}
          endpoint={productsTable}
          query={term_id}
          pageSize={50}
          showSizeChanger
          searchInput
          tableTitle="Productos y/o entregables"
        />
      </Modal>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        TÉRMINOS DE REFERENCIA
      </Title>
      <Title level={3}>PROYECTO: {info && info.proyecto_nombre}</Title>
      <Paragraph>
        Los siguientes términos de referencia complementan el texto del contrato
        firmado entre las partes y están subordinados a dichos contratos.
      </Paragraph>
      <Card
        size={'small'}
        bordered={false}
        title={<Title level={3}>D. ASPECTOS JURÍDICOS Y ECONÓMICOS</Title>}
      >
        <Title level={4}>Forma de pago</Title>

        {info && (
          <>
            <div
              style={{
                justifyContent: 'space-around',
                display: 'flex',
                marginBottom: '1rem',
              }}
            >
              <CustomButton
                htmlType={'button'}
                text="Agregar pago"
                onClick={() =>
                  setInitialValues({ numero: info.max_num_pago + 1 })
                }
              />
              <CustomButton
                htmlType={'button'}
                text="Ver resumen de productos"
                type="default"
                onClick={() => setShowProducts(true)}
              />
            </div>
            <Alert
              message="Información:"
              description={
                <>
                  <ul>
                    <li>
                      El valor total del contrato es: {info?.moneda_simbolo}{' '}
                      {(info?.valor_contrato || 0)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                      {info?.moneda_descripcion}
                    </li>
                    <li>
                      Ha asignado: {info?.moneda_simbolo}{' '}
                      {(info?.valor_asignado || 0)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                      {info?.moneda_descripcion}
                    </li>
                    {(info?.valor_contrato || 0) - (info?.valor_asignado || 0) >
                      0 && (
                      <li>
                        Valor pendiente por asignar: {info?.moneda_simbolo}{' '}
                        {(
                          (info?.valor_contrato || 0) -
                          (info?.valor_asignado || 0)
                        )
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                        {info?.moneda_descripcion}
                      </li>
                    )}
                    {(info?.valor_contrato || 0) - (info?.valor_asignado || 0) <
                      0 && (
                      <li>
                        Ha sobrepasado el valor total del contrato. Por favor,
                        verifique los datos.
                      </li>
                    )}
                  </ul>
                </>
              }
              type={
                (info?.valor_contrato || 0) - (info?.valor_asignado || 0) !== 0
                  ? 'error'
                  : 'info'
              }
            />
          </>
        )}
        <AjaxTable
          columns={columns}
          searchInput
          tableTitle={'Listado de pagos'}
          expandedRowRender={{ expandedRowRender }}
          endpoint={filterAjaxTable}
          reloadSource={reloadSource}
          query={`/?filter[termino]=${term_id}`}
        />
        <CustomButton
          type={'default'}
          className={'back-button'}
          htmlType="button"
          text={
            <Link
              to={`${INTERNAL_LINKS.TERM}/${term_id}/${parseInt(
                match.params.project_id,
              )}/${parseInt(match.params.contract_id)}/?module=D`}
            >
              Volver
            </Link>
          }
        />
      </Card>
    </>
  );
}
